import Login from './login';
import SetPassword from './set-password';
import SingUp from './sing-up';

export default Login;

export {SingUp, SetPassword};
